export default __webpack_public_path__ + "static/media/lorem3.2eecd704.svg";